// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import DataViewer from '../core/data-viewer';
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-json.scss';

const servicesDataKey = 'mediaItemCix';

class MediaItemCIX extends Component {
    getDataViewerProps() {
        return {
            className: 'mediaitem-json--data-viewer',
            defaultExpandKeys: ['DataPackage', 'Period', 'VodCatalogueProvider', 'VodItem'],
            mode: 'xml',
            searchData: this.getXmlData(),
        };
    }

    getMediaItemGuid() {
        const {routerParams} = this.props;

        return routerParams.guid;
    }

    getPaginationProps() {
        return {
            maxResults: 50000,
            maxPages: 9,
        };
    }

    getRecordDetailsProps() {
        return {
            blacklistKeys: ['xml'],
            className: 'mediaitem-json--record-details',
            whitelistKeys: ['guid'],
        };
    }

    getXmlData() {
        const {searchData} = this.props;

        return get(searchData, '0.xml');
    }

    renderDataViewer() {
        const {searchData} = this.props;

        return searchData.length ? (
            <DataViewer {...this.getDataViewerProps()} />
        ) : (
            <div className="mediaitem-json--no-items">CIX Catalog data not available for this Media Item.</div>
        );
    }

    render() {
        const {fetching, searchData} = this.props;

        return this.getMediaItemGuid() ? (
            <div className="mediaitem-json">
                <div className="mediaitem-json--content">
                    <div className="mediaitem-json--title">Media Item CIX</div>
                    <RecordDetails {...this.getRecordDetailsProps()} searchData={searchData} />
                    <div className="mediaitem-json--title">CIX Catalog Data</div>
                    {this.renderDataViewer()}
                    <Loading loading={fetching} />
                </div>
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

MediaItemCIX.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(MediaItemCIX, servicesDataKey);
